module.exports = __webpack_public_path__ + "static/img/aleksis.2ee6332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aleksis.png
// module id = YWOY
// module chunks = 0